import styles from "./userprofile.module.css";
import { Outlet, useLocation } from "react-router-dom";
import { Banner, BreadCrumb } from "../../../components/shared/index";
import UserSideBar from "./UserSideBar/UserSideBar";
const UserProfileOverview = () => {
  const { pathname } = useLocation();
  const parts = pathname.split("/");
const newPath = parts[parts.length - 1];

  return (
    <section className={styles.userprofile__wrapper}>
      {/* <BreadcrumbBanner
        newPath={newPath}
        heading="Trendy, comfortable, and uniquely you."
        imageUrl="https://images.pexels.com/photos/285171/pexels-photo-285171.jpeg?_gl=1*1q3as8n*_ga*MTAzODIwMzc4Mi4xNzY5MTY5NjM0*_ga_8JE65Q40S6*czE3Nzk2ODUyMjUkbzUkZzEkdDE3Nzk2ODUzNTIkajEyJGwwJGgw"
      /> */}

      <div className={styles.profileContentWrapper}>
        <div className={styles.userSideBar}>
          <UserSideBar />
        </div>

        <div className={styles.rightSection}>
          <Outlet />
        </div>
      </div>
    </section>
  );
};

const BreadcrumbBanner = ({ newPath, heading, imageUrl }) => {
  const labelMap = {
    profile: "Profile",
    order: "Orders",
    wishlist: "Wishlist",
    address: "My Address",
  };

  const displayLabel = labelMap[newPath] || "Profile";

  return (
    <>
      <BreadCrumb customPaths={[{ label: displayLabel, path: newPath }]} />
      <Banner heading={heading} imageUrl={imageUrl} />
    </>
  );
};

export default UserProfileOverview;
